import React, { useState } from 'react'
import { Modal, Form, Input, App } from 'antd'
import { useBnszcMutation } from '../../store/dianshangtaizhangApi'
import { useShangpingdingdanAddMutation } from '../../store/ReactWebSiteApi'
import dayjs from 'dayjs'
import { PlusSquareOutlined } from '@ant-design/icons';
function Bnszc(props) {
    const [info, setInfo] = useState({
        qy_name: '',
        yh_phone: '',
        yh_name: '',
        dd_byxkh_name: '',
        dd_content: '',
    })
    const {message} = App.useApp()
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm()
    const [submitAdd] = useBnszcMutation()
    const [orderAdd] = useShangpingdingdanAddMutation()
    const onCreateClient = () => {        
        submitAdd({
            'qy_name': info.qy_name,
            'qy_state': '1',
            'yh_phone': info.yh_phone,
            'yh_name': info.yh_name,
            'yh_qx': '管理',
            'yh_juese': '1',
            'yh_state': '1'
        }).then((res) => {
            if (res.data.Status === 'success') {
                orderAdd({
                    'dd_eowg_id': props.eowg_id,
                    'dd_eowg_name': props.eowg_name,
                    'dd_eowgg_id': props.eowgg_id,
                    'dd_eowgg_name': props.eowgg_name,
                    'dd_byxkh_id': '',
                    'dd_byxkh_name': info.dd_byxkh_name,
                    'dd_xf_date': dayjs().format('YYYY-MM-DD'),
                    'dd_dq_date': dayjs().add(1, 'month').format('YYYY-MM-DD'),
                    'dd_xf_amount': '1',
                    'dd_xf_num': '',
                    'dd_content': info.dd_content,
                    'dd_uid': localStorage.getItem('eu_id'),
                    'dd_uname': localStorage.getItem('eu_name'),
                    'dd_qy_id': '',
                    'dd_qy_name': info.qy_name,
                    'dd_database': props.eowg_shouming,
                    'dd_eowgt_id': props.eowgt_id,
                    'dd_eowgt_name': props.eowgt_name,
                    'dd_eowgts_id': props.eowgts_id,
                    'dd_eowgts_name': props.eowgts_name,
                })
                .then((res) => {
                    if (res.data.Status === 'success') {
                        message.success('新增成功！')
                    } else {
                        message.error('新增失败！' + res.data.Message)
                    }
                })
            } else {
                message.error('注册失败！' + res.data.Message)
            }
        })
        setOpen(false);
    };
    return (
        <>
            <a onClick={() => setOpen(true)}><PlusSquareOutlined /> 新用户</a>
            <Modal 
                open={open} 
                onCancel={() => setOpen(false)} 
                onOk={onCreateClient}
                title="新增企业用户"
            >
                <Form
                  form={form}
                  labelCol={{span:6}}
                  wrapperCol={{span:18}}
                >
                    <Form.Item label="企业全称" name="dd_byxkh_name">
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,dd_byxkh_name:e.target.value}))
                            }}
                        />
                    </Form.Item>                   
                    <Form.Item label="企业简称" name="qy_name">
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,qy_name:e.target.value}))
                            }}
                        />
                    </Form.Item>                   
                    <Form.Item label="管理员姓名" name="yh_name">
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,yh_name:e.target.value}))
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="管理员手机号" name="yh_phone">
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,yh_phone:e.target.value}))
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="订单备注" name="dd_content">
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,dd_content:e.target.value}))
                            }}
                        />
                    </Form.Item>
                   
                </Form>
            </Modal>
        </>
    )
}

export default Bnszc